export default __webpack_public_path__ + "static/media/servers.8d3a2e31.png";